import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/modules/index.js'
import request from './utils/request.js'
import 'vant/lib/index.css'
import './assets/styles/global.css'

// 按需引入 Vant 组件
import { 
  Button, 
  NavBar, 
  Tabbar, 
  TabbarItem,
  Cell, 
  CellGroup,
  Field,
  Form,
  Dialog,
  Toast,
  Icon,
  Swipe, 
  SwipeItem
} from 'vant'
const app = createApp(App)

// 注册 Vant 组件
app.use(Button)
app.use(NavBar)
app.use(Tabbar)
app.use(TabbarItem)
app.use(Cell)
app.use(CellGroup)
app.use(Field)
app.use(Form)
app.use(Dialog)
app.use(Toast)
app.use(Icon)
app.use(Swipe)
app.use(SwipeItem)

app.use(router)
app.use(store)


app.config.globalProperties.$api = request


app.mount('#app')